<template>
    <div id="transcription-list-wrapper" class="transcription-list d-flex flex-column justify-content-end">
      <div
        class="d-flex flex-column align-items-start"
        :style="{
          marginTop: `${transcriptionOffset}px`
        }"
      >
        <p v-for="(item, index) in transcriptions" :key="index" class="transcription-list--item">
          <strong>{{item.identity == selfIdentity ? 'You' : item.identity}}: </strong>{{item.text}}
        </p>
        <div id="transcription-last-element" class="transcription-list--last"></div>
      </div>
      <span class="show-more" @click="showMore">
        <feather type="chevrons-up" size="14" />
      </span>
    </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "../events/eventBus";

export default {
  name: "TranscriptionList",
  props: {
    selfIdentity: String,
  },
  data() {
    return {
      transcriptionOffset: 0,
    }
  },
  computed: {
    ...mapGetters("transcription", ["transcriptions", "transcriptionResultJsonIds"]),
    ...mapGetters("user", ["userLanguage"])
  },
  created() {
    this.$store.commit("transcription/initTranscriptions");
    this.transcriptionOffset = 0;

    EventBus.$on("sdk:receive-transcription", async (data) => {
      const {
        uid,
        identity,
        languages,
        status,
        transcription,
        translations
      } = data;

      let translatedText;
      try {
        translatedText = languages && languages.to.substring(0, 2) == (this.userLanguage || "en").substring(0, 2) ? translations.to : null;
      } catch (err) {
        translatedText = transcription;
      }

      if (!translatedText || translatedText == "") return;

      if (!this.transcriptionResultJsonIds.includes(uid)) {
        this.$store.commit("transcription/addTranscriptionResultJsonId", uid);
        this.$store.commit("transcription/addTranscription", {
          text: translatedText,
          status,
          identity,
          uid,
          languages
        });
      } else {
        const lastTranscriptionIndex = this.transcriptions.findLastIndex(item => item.uid == uid);
        this.$store.commit("transcription/insertTranscription", {
          insertIndex: lastTranscriptionIndex,
          transcription: {
            text: translatedText,
            status,
            identity,
            uid,
            languages
          }
        });        
      }

      this.moveToBottom();
    });
  },
  methods: {
    moveToBottom() {
      setTimeout(() => {
        const $ = window.$;
        const wrapperEle = $("#transcription-list-wrapper");
        const wrapperElePos = wrapperEle.position();
        const lastElement = $("#transcription-last-element");
        const lastElementPos = lastElement.position();
        const offset = lastElementPos.top - (wrapperElePos.top + wrapperEle.outerHeight());
        if (offset > 0) {
          this.transcriptionOffset -= offset;
        }
      }, 100)
    },
    showMore() {
      this.$emit("showMore");
    },
  },
  beforeDestroy() {
    EventBus.$off("sdk:receive-transcription");
  },
}
</script>

<style lang="scss" scope>
.transcription-list {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  > div {
    width: 100%;
    min-height: 100%;
    transition: margin-top 100ms;
  }

  &--item {
    margin: 0;
    color: white;
    text-align: left;
  }

  &--last {
    width: 100%;
    height: 0;
  }

  .show-more {
    cursor: pointer;
    position: absolute;
    top: 2px;
    right: 0;
    font-size: 10px;
    color: white;
    padding: 2px;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    border-radius: 2px;
  }
}
</style>
